module.exports = __webpack_public_path__ + "img/xin.a5850c20.png";